<template>
  <div>
    <!-- Placeholder for approve modal - can be implemented using existing modal system -->
  </div>
</template>

<script>
export default {
  name: 'ApproveModal',
}
</script>
